module.exports = __webpack_public_path__ + "static/media/Product Decision Tree.66243747.pdf";